// 入库纯函数（EP-008-S1 / GDD 03 §②-2.1）。
// 已存在 giftId → count += 1（firstObtainedAt 不变）；不存在 → 新增 stack（count=1）。
// 同一 trip 内多次出现同一 giftId（sameGiftMaxPerTrip 上限内）会被合并累加。
// 返回新数组，排序：firstObtainedAt 升序，相同时间戳按 giftId 字典序（GDD 03 §2.2）。
// 本文件不接触 lastSettledTripId（闸门只由 settleTrip.ts 关）。
//
// 注意：本文件位于 src/domain，CI 守门禁止 Date.now / Math.random / setInterval / rAF；
// 时间一律由注入的 `now` 提供。
import type { InventoryStackV1 } from '../../save/types';

export function upsertStacks(
  inventory: InventoryStackV1[],
  giftIds: string[],
  now: number,
): InventoryStackV1[] {
  const map = new Map<string, InventoryStackV1>();
  for (const s of inventory) map.set(s.giftId, { ...s });

  for (const giftId of giftIds) {
    const existing = map.get(giftId);
    if (existing) {
      existing.count += 1;
      // 累加时 isRead 保持原值（已读/未读状态不因数量增加而改变）
    } else {
      map.set(giftId, { giftId, count: 1, firstObtainedAt: now, isRead: false });
      // 🆕 v2.1：新入库礼物标记为未读（驱动空间礼物 tab 角标 + TopBar 空间按钮合计未读数）
    }
  }

  return [...map.values()].sort((a, b) => {
    if (a.firstObtainedAt !== b.firstObtainedAt) return a.firstObtainedAt - b.firstObtainedAt;
    if (a.giftId < b.giftId) return -1;
    if (a.giftId > b.giftId) return 1;
    return 0;
  });
}
